export const formatExpiryTime = (expiresAt) => {
    if (!expiresAt) return "N/A";

    const date =
        typeof expiresAt === "string"
            ? new Date(parseInt(expiresAt, 10))
            : new Date(expiresAt);

    return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        // hour: "2-digit",
        // minute: "2-digit",
        // second: "2-digit",
        // hour12: true,
    });
};


export const getExpiryRelativeTime = (expiresAt) => {
    if (!expiresAt) return "N/A";

    const now = Date.now();
    const diff = expiresAt - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

    return `${days} days ${hours} hours remaining`;
};

export const getRemainingTimeParts = (expiresAt) => {
    if (!expiresAt) return null;

    const expiry =
        typeof expiresAt === "string"
            ? parseInt(expiresAt, 10)
            : expiresAt;

    const diff = expiry - Date.now();

    if (diff <= 0) return null;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { days, hours, minutes, seconds };
};

export const formatRemainingTime = (parts) => {
  if (!parts) return "Expired";

  const { days, hours, minutes, seconds } = parts;

  const segments = [];

  if (days > 0) segments.push(`${days} day${days > 1 ? "s" : ""}`);
  if (hours > 0) segments.push(`${hours} hr${hours > 1 ? "s" : ""}`);
  if (minutes > 0) segments.push(`${minutes} min`);
  segments.push(`${seconds} sec`);

  return segments.join(" ");
};
